import { render, staticRenderFns } from "./agence-google-ads-pantin.vue?vue&type=template&id=1d23915c&scoped=true&"
import script from "./agence-google-ads-pantin.vue?vue&type=script&lang=js&"
export * from "./agence-google-ads-pantin.vue?vue&type=script&lang=js&"
import style0 from "./agence-google-ads-pantin.vue?vue&type=style&index=0&id=1d23915c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23915c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,TakeStock: require('/app/components/TakeStock.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
